import * as TypSubjektu from "./../api/gen/proxioapi/TypSubjektu";
import {formatDate, localUTCToDate} from "./commons";

/**
 * Základní formátování názvu subjektu, BEZ adresy, a BEZ dalších údajů jako např. IČO apod.
 * @param subjekt objekt subjektu
 * @return naformátový řetězec popisu subjektu, např. "ing. jan metelka" nebo "Obec Testovací" apod.
 */
export function getNazev(subjekt: AbstractSubjekt) {
    let result = null;

    switch (subjekt.typSubjektu) {
        case TypSubjektu.FO: {
            let parts = [];
            subjekt.titulPred && parts.push(subjekt.titulPred);
            subjekt.jmeno && parts.push(subjekt.jmeno);
            subjekt.prijmeni && parts.push(subjekt.prijmeni);
            subjekt.titulZa && parts.push(subjekt.titulZa);

            result = parts.join(" ");
        }
            break;
        case TypSubjektu.FOP:
            if (subjekt.nazev) {
                result = subjekt.nazev;
            } else {
                if (subjekt.fyzickaOsoba) {
                    let parts = [];
                    subjekt.fyzickaOsoba.titulPred && parts.push(subjekt.fyzickaOsoba.titulPred);
                    subjekt.fyzickaOsoba.jmeno && parts.push(subjekt.fyzickaOsoba.jmeno);
                    subjekt.fyzickaOsoba.prijmeni && parts.push(subjekt.fyzickaOsoba.prijmeni);
                    subjekt.fyzickaOsoba.titulZa && parts.push(subjekt.fyzickaOsoba.titulZa);

                    result = parts.join(" ");

                    if (subjekt.ico) {
                        const dopln = subjekt.ico ? `, (${subjekt.ico})` : "";
                        result += dopln;
                    }
                } else {
                    result = "-";
                }
            }
            break;
        case TypSubjektu.PO:
            result = subjekt.nazev;
            break;
        case TypSubjektu.NO:
            result = subjekt.nazev;
            break;
    }

    return result;
}

/**
 * Úplný název subjektu BEZ adresy.
 * @param subjekt subjekt
 * @return naformátový řetězec popisu subjektu, např. "ing. jan metelka csc, RČ: 8555191873" nebo "Obec Testovací, IČO: 00234897" apod.
 */
export function getUplnyNazev(subjekt: AbstractSubjekt) {
    const nazev = getNazev(subjekt);

    switch (subjekt.typSubjektu) {
        case TypSubjektu.FO: {
            let dopln = "";
            if (subjekt.rc) {
                dopln = `, RČ: ${subjekt.rc}`;
            } else if (subjekt.datumNarozeni) {
                dopln = ", nar: " + formatDate(localUTCToDate(subjekt.datumNarozeni));
            }

            return nazev + dopln;
        }
            break;
        case TypSubjektu.FOP: {
            let dopln = "";
            if (subjekt.ico) {
                dopln = `, IČO: ${subjekt.ico}`;
            }

            return nazev + dopln;
        }
            break;
        case TypSubjektu.PO: {
            let dopln = "";
            if (subjekt.ico) {
                dopln = `, IČO: ${subjekt.ico}`;
            }

            return nazev + dopln;
        }
            break;
        case TypSubjektu.NO:
            return nazev;
    }
}

/**
 * Úplná indentifikace subjektu včetně adresy. Pro formát adresy je použito pole popis u adresy.
 * @param subjekt subjekt
 * @return naformátový řetězec popisu subjektu, např. "ing. jan metelka csc, RČ: 8555191873, Brojova 1909/1, Plzeň, 326 00 Plzeň 26" nebo "Obec Testovací, IČO: 00234897, Brojova 1909/1, Plzeň, 326 00 Plzeň 26" apod.
 */
export function getUplnaIdentifikace(subjekt: AbstractSubjekt) {
    const uplnyNazev = getUplnyNazev(subjekt);
    if (subjekt.adresaTrv) {
        return uplnyNazev + ", " + subjekt.adresaTrv.popis;
    } else {
        return uplnyNazev;
    }
}
